import { decrypt } from '../../util/Security';
import { deleteDocument, postDocuments } from '../api/DocumentApi';
import { fetchCandidateDetails } from './CandidateAction';

export const uploadDocs = (document) => async (dispatch) => {
    try {
        const result = await postDocuments(document, dispatch);
        if (result?.data) {
            dispatch({ type: 'DOC_UPLOAD_PROGRESS', payload: result.data });
            let loggedIn = localStorage.getItem('login');
            if (loggedIn) {
                let data = decrypt(loggedIn);
                dispatch(fetchCandidateDetails(data?.candidateId));
            }
            let notify = { msg: result.data.message, theme: 'success' };
            dispatch({ type: 'NOTIFICATION', payload: notify });
        } else if (result?.error) {
            let notify = { msg: result.error, theme: 'error' };
            dispatch({ type: 'DOC_UPLOAD_PROGRESS', payload: result });
            dispatch({ type: 'NOTIFICATION', payload: notify });
        }
    } catch (error) {
        return error;
    }
};

export const removeDocument = (docDetails) => async (dispatch) => {
    const response = await deleteDocument(docDetails);
    if (response?.data?.status === 200) {
        let loggedIn = localStorage.getItem('login');
        if (loggedIn) {
            let data = decrypt(loggedIn);
            dispatch(fetchCandidateDetails(data?.candidateId));
            let notify = { msg: response.data.message, theme: 'success' };
            dispatch({ type: 'NOTIFICATION', payload: notify });
        }
    } else if (response?.data?.status === 204) {
        let notify = { msg: response.data.message, theme: 'error' };
        dispatch({ type: 'NOTIFICATION', payload: notify });
    }
};
